/** @prettier */

import {
  FormControlLabel,
  FormGroup,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Checkbox,
} from '@mui/material';
import React, {useState} from 'react';
import {useParams} from 'react-router-dom';
import {useTranslation} from 'react-i18next';

//MTH component import
import APIErrorMessage from '../../component/APIErrorMessage';
import {PrimaryButton, SecondaryButton} from '../../component/BasicButton';
//API import
import {
  deleteCompositionsSLIFUnit,
  getCompositionsSLIFUnit,
} from '../../API/API_Collection';
//interface import
import * as apiIF from '../../Type/api';

import {sortByUnicode} from '../../functions/sort';

/**
 * その他空調機削除ダイアログ
 * @param props props
 * @returns JSX.Element
 */
export default function OtherDeleteDialog(props: {
  /** 削除する空調機ID */
  slOtherID: string;
  /** 削除する空調機の名前 */
  slOtherName: string;
  /** 削除する空調機の情報（set関数） */
  setSLOtherInfo: React.Dispatch<
    React.SetStateAction<apiIF.res.getCompositionsSLIFUnit | null>
  >;
  /** ダイアログを開くかどうか */
  isOpenDialog: boolean;
  /** ダイアログを開くかどうか（set関数） */
  setIsOpenDialog: React.Dispatch<React.SetStateAction<boolean>>;
  /** 課金しているかどうか */
  isBilling: boolean;
  /** GW毎の構成情報未反映の有無（set関数） */
  setHasConfigGW: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  const trans = useTranslation().t; //翻訳関数
  //パスパラメータ取得
  const {siteID, gwID} = useParams();

  const [checked1, setChecked1] = useState(false); //1行目のチェックボックス
  const [checked2, setChecked2] = useState(false); //2行目のチェックボックス
  const [okBtnDisabled, setOKBtnDisabled] = useState(true); //OKボタン非表示フラグ
  const [isOpenErrorDialog, setIsOpenErrorDialog] = useState(false); //APIエラー時エラーメッセージ表示
  const [apiWait, setAPIWait] = useState(false); //API応答待ちフラグ

  /**
   * OKボタン押下時処理
   */
  const ouDelete = () => {
    //パスパラメータを取得できない場合
    if (siteID === undefined || gwID === undefined) {
      return;
    }

    setOKBtnDisabled(true);
    setAPIWait(true);

    //空調機を削除
    deleteCompositionsSLIFUnit(siteID, gwID, props.slOtherID)
      .then(() => {
        //空調機の情報を取得
        return getCompositionsSLIFUnit(siteID, gwID, {'max-result': 400});
      })
      .then(response => {
        //表示内容をUnicode順に並び替え
        response['unit-informations'].sort(sortByUnicode('unit-name'));
        props.setSLOtherInfo(() => response);
        props.setHasConfigGW(props.isBilling); //課金している場合のみ表示
        handleClose();
      })
      .catch(() => {
        setIsOpenErrorDialog(true);
      })
      .finally(() => {
        setAPIWait(false);
      });
  };
  /**
   * CANCELボタン押下時処理
   */
  const handleClose = () => {
    props.setIsOpenDialog(false);
    setChecked1(false);
    setChecked2(false);
  };

  /**
   * チェックボックス押下時処理
   * @param event
   * @param check 押下したチェックボックスの名前
   */
  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    check: string
  ) => {
    if (check === 'check1') {
      setChecked1(event.target.checked);
      if (event.target.checked === false || checked2 === false) {
        setOKBtnDisabled(true);
      } else {
        setOKBtnDisabled(false);
      }
    }
    if (check === 'check2') {
      setChecked2(event.target.checked);
      if (event.target.checked === false || checked1 === false) {
        setOKBtnDisabled(true);
      } else {
        setOKBtnDisabled(false);
      }
    }
  };

  return (
    <>
      <Dialog
        open={props.isOpenDialog}
        onClose={handleClose}
        aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">
          {trans('OtherDeleteDialog.title')}
        </DialogTitle>
        <DialogContent>
          {/* 室内機名称の表示 */}
          <DialogContentText>
            {trans('OtherDeleteDialog.msg')} {props.slOtherName}
          </DialogContentText>
          {/* チェックボックス */}
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  onChange={e => handleChange(e, 'check1')}
                  id={`mv-Check1DeleteIf${props.slOtherName}`}
                />
              }
              checked={checked1}
              label={trans(
                'OtherDeleteDialog.checkboxDescription.unrestorable'
              )}
            />
          </FormGroup>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  onChange={e => handleChange(e, 'check2')}
                  id={`mv-Check2DeleteIf${props.slOtherName}`}
                />
              }
              checked={checked2}
              label={trans(
                'OtherDeleteDialog.checkboxDescription.operationDataDeleted'
              )}
            />
          </FormGroup>
        </DialogContent>
        <DialogActions>
          <SecondaryButton
            disabled={apiWait}
            onClick={handleClose}
            buttonText={trans('OtherDeleteDialog.buttonTxt.cancel')}
            id={`mv-btnCancelDeleteIf${props.slOtherName}`}
          />
          <PrimaryButton
            onClick={ouDelete}
            buttonText={trans('OtherDeleteDialog.buttonTxt.ok')}
            id={`mv-btnOkDeleteIf${props.slOtherName}`}
            disabled={okBtnDisabled}
            apiWait={apiWait}
          />
        </DialogActions>
      </Dialog>
      <APIErrorMessage
        open={isOpenErrorDialog}
        setOpen={setIsOpenErrorDialog}
        id={`${props.slOtherName}DeleteErrDlgBtn`}
      />
    </>
  );
}
